import {
  ADD_USER_TASK_REQUEST,
  DELETE_USER_TASK_REQUEST,
  SET_ACTIVE_TASK_REQUEST,
  SET_ACTIVE_TASK_RESPONSE,
  UPDATE_REMINDERS,
  UPDATE_USER_TASK_REQUEST
} from '../constants/actionTypes';

export const initialState = {
  activeTask: {},
  reminders: JSON.parse(localStorage.getItem('remindersSent'))
};

const tasks = (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_USER_TASK_REQUEST:
    case UPDATE_USER_TASK_REQUEST:
    case DELETE_USER_TASK_REQUEST:
    case SET_ACTIVE_TASK_REQUEST:
      return {
        ...state
      };

    case UPDATE_REMINDERS:
      return {
        ...state,
        reminders: payload
      };

    case SET_ACTIVE_TASK_RESPONSE:
      return {
        ...state,
        activeTask: payload
      };

    default:
      return {
        ...state
      };
  }
};

export default tasks;
